import * as React from "react";
import { isNative, isIOS, isAndroid, isMobileBuild } from "./index";

interface PlatformState {
  isNative: boolean;
  isIOS: boolean;
  isAndroid: boolean;
  isWeb: boolean;
  isMobileBuild: boolean;
  isOnline: boolean;
  setIsOnline: (online: boolean) => void;
}

const PlatformContext = React.createContext<PlatformState | null>(null);

export function PlatformProvider({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  const [isOnline, setIsOnline] = React.useState(true);

  const value = React.useMemo<PlatformState>(
    () => ({
      isNative: isNative(),
      isIOS: isIOS(),
      isAndroid: isAndroid(),
      isWeb: !isNative(),
      isMobileBuild,
      isOnline,
      setIsOnline,
    }),
    [isOnline],
  );

  return (
    <PlatformContext.Provider value={value}>
      {children}
    </PlatformContext.Provider>
  );
}

export function usePlatform(): PlatformState {
  const ctx = React.useContext(PlatformContext);
  if (!ctx) throw new Error("usePlatform must be used inside PlatformProvider");
  return ctx;
}
